import { LocalDateTime } from "@js-joda/core";
import { isReminderRelevantForVisit } from "../clockInOutUtils";
import { isLoading } from "../Loading";
import { ClockedInStatusDetails, VisitInstanceDetails } from "../messages";
import { STRINGS } from "../strings";
import { AppScheduledVisitsState } from "../system/AppState/AppScheduledVisitsState";
import { translate } from "../translate";
import { flmap } from "../utils/fmap";
import { ClockActionBannerData } from "./ClockActionBanner";
import { isDefined } from "./Generic/IsDefined";

/**
 * This function gets the scheduled visits state and clocked in status details.
 * If the caregiver is clocked in or there is an upcoming scheduled visit -
 * returns props accordingly, otherwise returns null
 */
export const getClockActionBannerProps = (
  scheduledVisits: AppScheduledVisitsState,
  status: ClockedInStatusDetails | null
): ClockActionBannerData | null => {
  if (status !== null) {
    const clockInTime = isDefined(status.clockInTime)
      ? status.clockInTime
      : LocalDateTime.ofInstant(status.clockedInAt);
    return {
      labelHeader: translate(STRINGS.CLOCKED_IN_AT),
      labelBody: translate(STRINGS.DONT_FORGET_TO_CLOCK_OUT),
      buttonString: translate(STRINGS.CLOCK_OUT),
      visitInstanceId: status.visitInstanceId,
      clockTime: clockInTime,
      type: "OUT",
    };
  }

  const presentVisit = flmap(scheduledVisits, (visit) =>
    visit.scheduledVisitDetails.find(
      (x: VisitInstanceDetails) =>
        isReminderRelevantForVisit(x, LocalDateTime.now()) && x.clockInTime === null
    )
  );

  if (!isLoading(presentVisit) && isDefined(presentVisit)) {
    return {
      labelHeader: translate(STRINGS.VISIT_STARTS_AT),
      labelBody: translate(STRINGS.DONT_FORGET_TO_CLOCK_IN),
      buttonString: translate(STRINGS.CLOCK_IN),
      visitInstanceId: presentVisit.id,
      clockTime: presentVisit.startTimeLocal,
      type: "IN",
    };
  }

  return null;
};
